module.exports = __webpack_public_path__ + "static/intelisense-funcionando-312dcb5038210ea41adb8efa1783e420.png";